var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCalculatorApplicant)?_c('CalculatorScoreboardLayout'):_c('ScoreboardLayout')}
var staticRenderFns = []

export { render, staticRenderFns }